import { render } from "./DamageLocation.vue?vue&type=template&id=4ad6ecda&scoped=true"
import script from "./DamageLocation.vue?vue&type=script&lang=js"
export * from "./DamageLocation.vue?vue&type=script&lang=js"

import "./DamageLocation.vue?vue&type=style&index=0&id=4ad6ecda&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ad6ecda"

export default script